// Created by jarongallo at 4/8/21
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withApollo } from '@apollo/react-hoc';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import UIListInputRow from '../../../../../../../components/UI/UIListInputRow';
import UIIconButton from '../../../../../../../components/UI/UIIconButton';
import { PlusIcon } from '../../../../../../../assets/icons';
import { showErrorMessage, showInfoMessage, showSuccessMessage } from '../../../../../../../redux/store/Control';
import { setSelectedRegion } from '../../../../../../../redux/store/user/actions';
import CreatePartnerHelper from './CreatePartnerHelper';

function CreatePartner(props) {
	const { hideModal } = props;
	let { selectedRegion } = props.currentUser;
	const { regionConfig } = selectedRegion;

	const [partnerName, setPartnerName] = useState('');

	return (
		<div>
			<UIListInputRow label={'Partner name'} placeholder={'partner name...'} value={partnerName} onChangeValue={(partnerName) => setPartnerName(partnerName)} />
			<UIIconButton
				disabledErrorMessage={CreatePartnerHelper.isPartnerNameValid(partnerName) ? undefined : 'Please enter a partner name.'}
				isDisabled={!CreatePartnerHelper.isPartnerNameValid(partnerName)}
				dark
				text={'Create partner'}
				onClick={() => CreatePartnerHelper.createPartner(partnerName, selectedRegion, regionConfig, props.client, hideModal, props.showInfoMessage)}
				icon={PlusIcon.grey}
			/>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		control: state.control,
		currentUser: state.currentUser,
		filters: state.filters
	};
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ showErrorMessage, showSuccessMessage, setSelectedRegion, showInfoMessage }, dispatch);

CreatePartner.propTypes = { partnerName: PropTypes.string, partnerConfig: PropTypes.object };

export default connect(mapStateToProps, mapDispatchToProps)(withApollo(CreatePartner));
